module.exports = __webpack_public_path__ + "static/media/meh-blank.8269250b.svg";